import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'
import { playDummyAudio } from '../utils'

// Connects to data-controller="track"
export default class extends Controller {
  static targets = ['form', 'track', 'unplayedBadge']
  static values = { trackId: Number, unpermitted: Boolean }
  static outlets = ['body']

  initialize() {
    const params = new URLSearchParams(window.location.search)
    const initialTrackId = parseInt(params.get('track'))

    if (this.trackIdValue === initialTrackId) {
      const nextUrl = window.location.href.slice(0, window.location.href.indexOf('?'))
      history.replaceState(null, '', nextUrl)
      this.play()
    }
  }

  play(e = null) {
    if (e) e.preventDefault()

    if (this.unpermittedValue) {
      this.showUnpermittedModal()
      return
    }

    playDummyAudio()
    setTimeout(() => {
      this.trackTarget.dataset.status = 'loading'
      this.formTarget.requestSubmit()
    }, 0)
  }

  scrollToPlayingTrack() {
    const mainScrollTop   = this.bodyOutlet.mainTarget.scrollTop
    const mainInnerHeight = this.bodyOutlet.mainTarget.getBoundingClientRect().height
    const targetTop       = mainScrollTop + this.element.getBoundingClientRect().top
    const targetBottom    = mainScrollTop + this.element.getBoundingClientRect().bottom
    const targetHeight    = this.element.getBoundingClientRect().height

    const offset = targetHeight / 2 // スクロール位置に少し余白を付ける

    if (mainScrollTop > targetTop) {
      this.bodyOutlet.mainTarget.scrollTop = targetTop - offset
    } else if ((mainScrollTop + mainInnerHeight) <= targetBottom) {
      this.bodyOutlet.mainTarget.scrollTop = targetTop + targetHeight - mainInnerHeight + offset
    }
  }

  markAsPlayed() {
    this.unplayedBadgeTarget.classList.remove('with-unplayed-badge')
  }

  showUnpermittedModal() {
    const unpermittedModal = document.querySelector('#unpermitted-modal')
    new Modal(unpermittedModal).show()
  }
}
